/**
 * PostHog `source` tag for events originating in the "What do you want to do
 * today?" dashboard widget (see the source-property convention).
 */
export const WHAT_TO_DO_TODAY_SOURCE = 'dashboard_what_to_do_today';

/** Backend journey-step surface for the dashboard What To Do Today widget. */
export const WHAT_TO_DO_TODAY_SURFACE = 'dashboard_what_to_do_today';

/** URL attribution value for routes opened from the dashboard widget. */
export const WHAT_TO_DO_TODAY_COMING_FROM = 'whatToDoToday';

/** Existing query-param spelling used to trigger guided experiences. */
export const WHAT_TO_DO_TODAY_GUIDED_EXPERIENCE_PARAM = 'guidedExpirience';

/** Correct query-param spelling for new guided experiences. */
export const WHAT_TO_DO_TODAY_GUIDED_EXPERIENCE_PARAM_V2 = 'guidedExperience';

export const WHAT_TO_DO_TODAY_EVENTS = {
  stepStarted: 'what_to_do_today_step_started',
  destinationViewed: 'dashboard_destination_viewed',
  smartTaxOrganizerDocumentProcessed: 'smart_tax_organizer_document_processed',
} as const;

export const WHAT_TO_DO_TODAY_DASHBOARD_STEPS = {
  uploadFile: 'upload_file',
  smartTaxOrganizer: 'smart_tax_organizer',
  smartTaxDelivery: 'smart_tax_delivery',
  sendMessage: 'send_message',
} as const;

export const WHAT_TO_DO_TODAY_DESTINATIONS = {
  fileDetail: 'file_detail',
  smartTaxOrganizerDetail: 'smart_tax_organizer_detail',
  smartTaxDeliveryDispatch: 'smart_tax_delivery_dispatch',
} as const;
